<template>
    <div class="flex items-center h-full">
        <vs-button @click="haldleDelete" color="danger" type="border" icon-pack="feather" icon="icon-trash"></vs-button>            
    </div>
</template>
<script>
import { Delete_Leads } from '@/api/leads'
import { mapActions } from 'vuex'
export default {
  name: 'DeleteActions',
  
  mounted () {
    this.action = this.params.data.actionData
  },
  data () {
    return {
      action:{}
    }
  },
  methods: {
    ...mapActions(
      ['SET_DELETE_ID', 'SET_VIEW_LEADS_SIDEBAR', 'SET_VIEW_LEADS_SIDEBAR_DATA', 'SET_LEADS_TOGGLE_DATA']
    ),
    async haldleDelete () {
      const deleting_id = this.params.data.leads_id
      const payload = {
        leads_id: [deleting_id],
        customer_id: this.$store.getters.customerId
      }
      if (!this.params.data.actionData.toggle) {
        try {
          const data = await Delete_Leads(payload)
          this.SET_DELETE_ID(deleting_id)
          
          this.$vs.notify({
            title: 'Lead deleted',
            text: 'Lead deleted successfully',
            ...this.successProp()
          })
        } catch (error) {
          console.error(error)
        }
      } else {
        this.$vs.notify({
          title: 'Warning',
          text: 'Can’t remove an active lead. Please deactivate the lead first',
          ...this.warnProp()
        })
      }
      
    }
  }
}
</script>
